<template>
  <div class='footer'>
    <div class="content">
      <div class="flex jcb content-box">
        <div class="flex">
          <template v-for="(item,i) in list">
            <div :key="i" class="content-left">
              <p class="fs18 content-title">{{item.title}}</p>
              <p v-for="(val,ind) in item.children" :key="ind" class="color_fff fs14 content-item" :class="{'csp':!val.isNo}" @click="changeClickEvent(val)">
                {{val.name}}
              </p>
            </div>
          </template>
        </div>
        <div class="flex aic">
          <div class="tac">
            <img :src="kfInfo.wx_code" class="content-img" alt="">
            <p class="color_fff pt10">公众号</p>
          </div>
          <div class="tac pl40">
            <img :src="kfInfo.dl_code" class="content-img" alt="">
            <p class="color_fff pt10">下载APP</p>
          </div>
        </div>

      </div>
    </div>
    <div class="describe tac fs14">
      <p>{{describeInfo.label}}</p>
      <p class="flex aic jcc pt10">
        <span v-for="(item,i) in describeInfo.list" :key="i" class="dib pr25 csp describe-item" @click="changeDesc(i)">{{item}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'FooterBottom',
  computed: {
    ...mapGetters(['userInfo', 'kfInfo']),
  },
  data () {
    return {
      describeInfo: {
        label: '违法和不良信息信息举报邮箱：glcs@gelinedu.cn 其他方式：关注格灵课堂帮，回复："反馈"进行信息反馈',
        list: ['© 广州格林软件技术有限公司', '粤ICP备2024256356号-16A', '教育移动应用备案号：粤ICP备2024256356号-1', '网络文化经营许可证：粤网文〔2024〕4639-327号', '电信增值业务经营许可证：粤B2-20241849', '举报邮箱：glcs@gelinedu.cn', '公众号反馈：关注【格灵课堂帮】回复"反馈"']
      },
      list: [
        {
          id: 1,
          title: '关于我们',
          children: [
            { name: '公司介绍', prop: 'company' },
            { name: '加入我们', prop: 'join' },
          ]
        },
        {
          id: 2,
          title: '商务合作',
          children: [
            { name: '内容合作', prop: 'business' },
            { name: '会员合作', prop: 'business' },
            { name: '渠道合作', prop: 'business' },
            { name: '广告合作', prop: 'business' },
          ]
        },
        {
          id: 3,
          title: '服务',
          children: [
            { name: '帮助与反馈', prop: 'help' },
            { name: '用户协议', prop: 'user_protocol' },
            { name: '隐私政策', prop: 'privacy' },
            { name: '侵权举报与投诉', prop: 'tort' },
          ]
        },
        {
          title: '客服中心',
          children: [{ name: '电话：19303035318', isNo: true }, { name: '微信：19303035318', isNo: true }]
        },
      ],
    }
  },
  created () {
  },
  methods: {
    changeDesc (index) {
      let url = '';
      switch (index) {
        case 0:
          url = require('@/assets/images/yyzz.jpg');
          break;
        case 1:
          url = 'https://beian.miit.gov.cn/#/Integrated/index';
          break;
        case 2:
          url = 'https://app.eduyun.cn/mapp/appRecordList';
          break;
        case 3:
          url = require('@/assets/images/wlxkz.jpg');
          break;
        case 4:
          url = require('@/assets/images/dxxkz.jpg');
          break;
        case 6:
          url = require('@/assets/images/wx_qrcode.jpg');
          break;
      }
      open(url);
    },
    changeClickEvent (val) {
      if (val.isNo) { return; };
      if (val.prop === 'help' && !this.userInfo.uid) {
        this.ToLogin();
      } else {
        this.OpenRouter({
          path: '/footer/details',
          query: { type: val.prop }
        })
      }
    },
  }
}
</script>

<style scoped lang='less'>
.footer {
  height: 400px;
  background: #333f4e;
  .content {
    width: 1196px;
    margin: 0 auto;
    &-box {
      padding: 65px 0;
    }
    &-img {
      width: 142px;
      height: 142px;
    }

    &-title {
      font-weight: bold;
      color: #fff;
      padding-bottom: 17px;
    }
    &-item {
      &:not(:last-child) {
        padding-bottom: 22px;
      }
    }
  }
  .content-left {
    &:not(:last-child) {
      padding-right: 131px;
      .content-item:hover {
        text-decoration: underline;
      }
    }
  }
  .color_fff {
    font-weight: 400;
    color: #ffffff;
    opacity: 0.6;
  }
  .describe {
    font-size: 14px;
    color: #ffffff;
    opacity: 0.3;
    &-item {
      &:hover {
        text-decoration: underline;
        opacity: 1;
      }
    }
  }
  .pl40 {
    padding-left: 40px;
  }
}
</style>
